import React, { Component } from 'react';
import LetterOfAppealDownload from './LetterOfAppealDownload';
import LetterOfAppealForm from './LetterOfAppealForm';

class LetterOfAppealDisplay extends Component {   
    render() {
        const { submitted, pdfUrl } = this.props;
        let displayView;

        if (submitted) {
            displayView = <LetterOfAppealDownload pdfUrl={pdfUrl} />;
        } else {
            displayView = <LetterOfAppealForm />;
        }
        return (
            displayView
        )
    }
}
  
export default LetterOfAppealDisplay;